import { useSearchStore } from '@modules/feed/store/searchStore';
import { isEqual } from 'lodash';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import {
  EmptyWhereClause,
  OperationType,
} from 'v2/core/services/queryBuilder/whereClause';
import { INPUT_SEARCH_TYPE } from '../types';
import { toWhereClauseFromBaseCondition } from '../utils';

export function useSearchAnalysesWhereClause() {
  const baseCondition = useSearchStore(({ query }) => query.baseCondition);
  const filterWhereClause = useSearchStore(({ query }) => query.whereClause);

  const baseConditionWhereClause =
    toWhereClauseFromBaseCondition(baseCondition);

  if (isEqual(filterWhereClause, EmptyWhereClause)) {
    return baseConditionWhereClause;
  }

  if (baseCondition?.type === INPUT_SEARCH_TYPE.ADVANCED) {
    return filterWhereClause ?? EmptyWhereClause;
  }

  const whereClause = combineWhereClauses(
    baseConditionWhereClause,
    filterWhereClause ?? EmptyWhereClause,
    OperationType.AND,
  );

  return whereClause;
}
